(function(){
  function init(root){
    var track=root.querySelector('.gb-ships-now__track');
    if(!track){return;}
    var x=0, speed=0.5, paused=false, half=0;
    function measure(){half=track.scrollWidth/2;}
    measure();
    window.addEventListener('load',measure);
    window.addEventListener('resize',measure);
    setTimeout(measure,800);
    root.addEventListener('mouseenter',function(){paused=true;});
    root.addEventListener('mouseleave',function(){paused=false;});
    (function tick(){
      if(!paused && half>0){x-=speed; if(-x>=half){x+=half;} track.style.transform='translate3d('+x+'px,0,0)';}
      requestAnimationFrame(tick);
    })();
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('.gb-ships-now__marquee'), init); }
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
})();
